// extracted by mini-css-extract-plugin
export default {"links":"links_links__fjUOi","link":"links_link__iiVFV"};